/* jslint browser: true */
/* global window */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import ReactTable from 'react-table';
import moment from 'moment';
import { toast } from 'react-toastify';
import validator from 'validator';
import 'react-table/react-table.css';
import { apiUrl } from '../lib/constants';
import CommandesPro from './commande/CommandesPro';

class FormProfessionnel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pro: {
                email: '',
                etablissement: '',
                genre: '--',
                nom: '',
                prenom: '',
                adresse: '',
                postal: '',
                ville: '',
                credit: 1,
                telephone: '',
                siret: '',
                actif: true
            },
            programsColumns: [
                {
                    id: 'date',
                    Header: 'Date',
                    width: 100,
                    accessor: d => moment(d.date).format('DD[/]MM[/]YYYY')
                },
                {
                    id: 'nom',
                    Header: 'Nom',
                    accessor: d => d.nom
                },
                {
                    id: 'download',
                    Header: 'Télécharger',
                    width: 100,
                    accessor: d => d.nomFichier,
                    Cell: _props => (
                        <span className="number">
                            <a href={_props.value} target="_blank">
                                Télécharger
                            </a>
                        </span>
                    )
                }
            ],
            borderedStyle: {
                border: '1px #000 solid',
                padding: '36px 10px 10px 10px',
                margin: '15px auto',
                backgroundColor: '#F9F9F9'
            },
            minCredits: 1,
            isPro: false
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        if (this.props.proId !== undefined) {
            // Code executé en backOffice
            axios
                .get(apiUrl + '/api/v1/pro/' + this.props.proId)
                .then(response => {
                    axios
                        .get(
                            apiUrl +
                                '/api/v1/commande?id_pro=' +
                                this.props.proId
                        )
                        .then(_response => {
                            axios
                                .get(
                                    apiUrl +
                                        '/api/v1/programme?id_pro=' +
                                        this.props.proId
                                )
                                .then(_resp => {
                                    delete response.data.password;
                                    this.setState({
                                        pro: response.data,
                                        orders: _response.data,
                                        programs: _resp.data,
                                        minCredits: response.data.credit,
                                        isPro: false
                                    });
                                });
                        });
                });
        } else if (
            window.localStorage.getItem('token') !== '' &&
            !this.props.creation
        ) {
            // Code executé coté frontOffice
            axios
                .post(apiUrl + '/api/v1/getUserFromToken', {
                    token: window.localStorage.getItem('token')
                })
                .then(response => {
                    axios
                        .get(
                            apiUrl +
                                '/api/v1/commande?etat=1&id_pro=' +
                                response.data.id_pro
                        )
                        .then(_response => {
                            delete response.data.password;
                            this.setState({
                                pro: response.data,
                                orders: _response.data,
                                minCredits: response.data.credit,
                                isPro: true
                            });
                        });
                });
        } else if (window.localStorage.getItem('token') === '') {
            toast.warn("Vous n'êtes pas connecté");
        }
    }

    /**
     * Permet de transmettre les information collecté ou modifiée d'un utilisateur et de les envoyer au serveur
     * Une edition de pro est caracterisé par la presence d' l'id_pro contrairement a la creation
     */
    saveUser(e) {
        e.preventDefault();
        if (validator.equals(this.state.pro.genre, '--')) {
            toast.error('Séléctionnez un genre');
            return;
        }
        if (!validator.isEmail(this.state.pro.email)) {
            toast.error('Séléctionnez une adresse mail valide');
            return;
        }
        if (validator.isEmpty(this.state.pro.etablissement)) {
            toast.error('Saisir un etablissement');
            return;
        }
        if (validator.isEmpty(this.state.pro.nom)) {
            toast.error('Saisir un nom');
            return;
        }
        // e.preventDefault();
        axios
            .put(apiUrl + '/api/v1/pro', this.state.pro)
            .then(() => {
                toast.success('Professionnel sauvegardé');
                this.props.loadData();
                this.props.closeModal();
            })
            .catch(() => {});
    }

    handleChange(e) {
        const pro = this.state.pro;
        if (e.target.name === 'actif') {
            pro.actif = e.target.checked;
        } else {
            pro[e.target.name] = e.target.value;
        }
        this.setState({
            pro
        });
    }

    render() {
        return (
            <div className="pro-form">
                <form
                    style={!this.props.admin ? this.state.borderedStyle : {}}
                    onSubmit={e => this.saveUser(e)}
                >
                    {!this.props.admin ? <h3>Mes informations</h3> : <div />}
                    <div className="form-row">
                        <div className="form-active">
                            {!this.props.admin ? (
                                <p />
                            ) : (
                                <label htmlFor="actif">
                                    Actif
                                    <input
                                        style={{ width: '45%' }}
                                        type="checkbox"
                                        id="actif"
                                        name="actif"
                                        checked={this.state.pro.actif}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </label>
                            )}
                        </div>
                        <div className="form-credit">
                            <label htmlFor="credit">
                                Programmes &nbsp;&nbsp;
                                <input
                                    style={{ width: '40%' }}
                                    type="number"
                                    id="credit"
                                    name="credit"
                                    min={this.state.minCredits}
                                    value={this.state.pro.credit}
                                    disabled={!this.props.admin}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-company">
                            <label htmlFor="etablissement">
                                Etablissement*
                                <input
                                    required
                                    type="text"
                                    id="etablissement"
                                    name="etablissement"
                                    value={this.state.pro.etablissement}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                        <div className="form-siret">
                            <label htmlFor="siret">
                                SIRET
                                <input
                                    type="text"
                                    id="siret"
                                    name="siret"
                                    value={this.state.pro.siret}
                                    disabled={this.state.isPro}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-genre">
                            <label htmlFor="genre">
                                Genre<br />
                                <select
                                    name="genre"
                                    id="genre"
                                    onChange={e => this.handleChange(e)}
                                    value={this.state.pro.genre}
                                >
                                    <option value="--" disabled>
                                        --
                                    </option>
                                    <option value="Homme">Homme</option>
                                    <option value="Femme">Femme</option>
                                </select>
                            </label>
                        </div>
                        <div className="form-nom">
                            <label htmlFor="nom">
                                Nom*
                                <input
                                    required
                                    type="text"
                                    id="nom"
                                    name="nom"
                                    value={this.state.pro.nom}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                        <div className="form-prenom">
                            <label htmlFor="prenom">
                                Prenom
                                <input
                                    type="text"
                                    id="prenom"
                                    name="prenom"
                                    value={this.state.pro.prenom}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-adresse">
                            <label htmlFor="adresse">
                                Adresse
                                <input
                                    type="text"
                                    name="adresse"
                                    id="adresse"
                                    value={this.state.pro.adresse}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-postal">
                            <label htmlFor="postal">
                                Code postal
                                <input
                                    type="text"
                                    name="postal"
                                    id="postal"
                                    value={this.state.pro.postal}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                        <div className="form-ville">
                            <label htmlFor="ville">
                                Ville
                                <input
                                    type="text"
                                    name="ville"
                                    id="ville"
                                    value={this.state.pro.ville}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-telephone">
                            <label htmlFor="telephone">
                                Téléphone
                                <input
                                    type="tel"
                                    name="telephone"
                                    id="telephone"
                                    pattern="^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$"
                                    value={this.state.pro.telephone}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                        <div className="form-email">
                            <label htmlFor="email">
                                Email*
                                <input
                                    required
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={this.state.pro.email}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                    </div>

                    {this.props.admin && (
                        <button
                            type="button"
                            className="btn myBtn myBtnCancel pull-left"
                            onClick={() => this.props.closeModal()}
                        >
                            Annuler
                        </button>
                    )}
                    <button
                        type="submit"
                        className={
                            this.props.admin
                                ? 'btn myBtn pull-right'
                                : 'btn myBtn center-block'
                        }
                    >
                        Sauvegarder
                    </button>
                </form>
                <br />
                {this.props.proId !== undefined ? (
                    <div className="pro-tables">
                        <CommandesPro
                            commandes={this.state.orders}
                            style={{ float: 'left', marginLeft: '10px' }}
                        />
                        <div
                            className="pro-programs"
                            style={{ float: 'right', marginRight: '10px' }}
                        >
                            <h3>MES PROGRAMMES</h3>
                            <ReactTable
                                columns={this.state.programsColumns}
                                data={this.state.programs}
                                defaultPageSize={5}
                                previousText="Précédent"
                                nextText="Suivant"
                                loadingText="Chargement..."
                                noDataText="Aucune informations"
                                ofText="sur"
                                rowsText="lignes"
                                showPageSizeOptions={false}
                            />
                        </div>
                    </div>
                ) : (
                    <div />
                )}
                {!this.props.admin && (
                    <div className="pro-tables">
                        <CommandesPro
                            commandes={this.state.orders}
                            style={{
                                width: '80%',
                                margin: '0 auto',
                                display: 'block'
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

// Declaration des props du composant
FormProfessionnel.propTypes = {
    proId: PropTypes.number,
    closeModal: PropTypes.func,
    admin: PropTypes.bool,
    creation: PropTypes.bool,
    loadData: PropTypes.func
};
// Définition par defaut (si non-attribué a l'appel du composant) des props
FormProfessionnel.defaultProps = {
    proId: undefined,
    closeModal: () => false,
    admin: false,
    creation: false,
    loadData: () => false
};

export default FormProfessionnel;



// WEBPACK FOOTER //
// ./src/components/FormProfessionnel.js